import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const CreateTalentFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  label {
    // font-weight: 700;
  }
  div {
    display: flex;
  }

  .ant-input {
    height: 45px !important;
    border-radius: 5px;
    border: 1px solid #0000001a;
  }

  .field-wrapper {
    display: flex;
    flex-direction: column;
    margin: 10px 5px;
  }

  .basic-btn {
    margin-top: 10px;
  }
`
